import actionTypes from './action-types';
import wrappersTypes from './wrappers-types';
import { FONT_SIZE_MODIFIER_PREFIX, SUPPORTED_FONT_SIZES } from './font-size';
import {
  TEXT_INTENT_MODIFIER_PREFIX,
  TEXT_INDENT_STEP,
  MAX_TEXT_INDENT_VALUE,
} from './text-indent';

export default {
  actionTypes,
  wrappersTypes,
  CUSTOM_COLOR_CSS_VARIABLE: 'custom-color',
  TEXT_COLOR_CSS_VARIABLE: 'text-color',
  TEXT_COLOR_OPTIONS_VARIABLE: 'textColorOptions',
  ROOT_CSS_SELECTOR: ':root',
  CUSTOM_COLOR_TAG: wrappersTypes.customColor.tagName,
  FONT_SIZE_MODIFIER_PREFIX,
  SUPPORTED_FONT_SIZES,
  TEXT_INTENT_MODIFIER_PREFIX,
  TEXT_INDENT_STEP,
  MAX_TEXT_INDENT_VALUE,
};
